var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top-div-container"},[_c('div',{staticClass:"top-label-content"},[_vm._v("随着我国疫情防控进入“乙类乙管”常态化防控阶段，线下展览全面复苏，出国展览迎来新机遇。2023 年4月，国务院办公厅印发《关于推动外贸稳规模优结构的意见》，要求各地方和贸促机构、商协会进一步加大对外贸企业参加各类境外展会的支持力度，持续培育境外自办展会、扩大办展规模。")]),_c('div',{staticClass:"top-label1-content"},[_vm._v("——《2023中国展览经济发展报告》中国国际贸易促进委员会")])])])
}]

export { render, staticRenderFns }